var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[(_vm.isLoggedIn)?_c('profile'):_c('a',{class:_vm.$style.login,attrs:{"href":_vm.login}},[_vm._v(_vm._s(_vm.$t("login")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }